// Project modules
import {
	CompaniesState,
} from '@localTypes/company';
import {
	CompanyBuildingsState,
} from '@localTypes/companyBuildings';
import {
	CompanyEstablishmentsState,
} from '@localTypes/companyEstablishment';
import {
	CompanyEventsState,
} from '@localTypes/companyEvents';
import {
	CompanyLandsState,
} from '@localTypes/companyLands';
import {
	CompanyManagersState,
} from '@localTypes/companyManagers';
import {
	CompanyTransactionsState,
} from '@localTypes/companyTransactions';
import {
	GeoJsonState,
} from '@localTypes/geoJson';
import {
	appReducer,
	AppState,
} from '@stores/_slices/app';
import {
	companiesReducer,
} from '@stores/_slices/companies';
import {
	companyBuildingsReducer,
} from '@stores/_slices/companyBuildings';
import {
	companyEstablishmentsReducer,
} from '@stores/_slices/companyEstablishments';
import {
	companyEventsReducer,
} from '@stores/_slices/companyEvents';
import {
	companyLandsReducer,
} from '@stores/_slices/companyLands';
import {
	companyManagersReducer,
} from '@stores/_slices/companyManagers';
import {
	companyTransactionsReducer,
} from '@stores/_slices/companyTransactions';
import {
	demandsReducer,
	StoreDemands,
} from '@stores/_slices/demands';
import {
	deviceReducer,
	DeviceSliceInstance,
} from '@stores/_slices/device';
import {
	geoJsonReducer,
} from '@stores/_slices/geoJson';
import {
	mapReducer,
	MapSliceInstance,
} from '@stores/_slices/map';
import {
	matchingOffersDemandsReducer,
	StoreMatchingOffersDemands,
} from '@stores/_slices/matching_offers_demands';
import {
	offersReducer,
	StoreOffers,
} from '@stores/_slices/offers';
import {
	OffersEntryJsonStore,
	offersEntryReducer,
} from '@stores/_slices/offersEntry';
import {
	offersEntryContactsReducer,
	OffersEntryContactsStore,
} from '@stores/_slices/offersEntryContacts';
import {
	offersEntryEnumsReducer,
	OffersEntryEnumsStore,
} from '@stores/_slices/offersEntryEnums';
import {
	offersEntryLocationReducer,
	OffersEntryLocationStore,
} from '@stores/_slices/offersEntryLocation';
import {
	offersEntryLotsReducer,
	OffersEntryLotsStore,
} from '@stores/_slices/offersEntryLots';
import {
	offersEntryMediaReducer,
	OffersEntryMediaStore,
} from '@stores/_slices/offersEntryMedia';
import {
	specificationOffersReducer,
	StoreCollectionSpecificationOffers,
} from '@stores/_slices/specification_offers';
import {
	specificationsReducer,
	StoreSpecifications,
} from '@stores/_slices/specifications';
import {
	statusMsgsReducer,
	StoreStatusMsgsInstance,
} from '@stores/_slices/status_msgs';
import {
	StoreToastMsgsInstance,
	toastMsgsReducer,
} from '@stores/_slices/toast_msgs';
import {
	GlobalUser,
	userReducer,
} from '@stores/_slices/user';

export interface ReducerInstance {
	app?: AppState;
	companies?: CompaniesState;
	companyBuildings?: CompanyBuildingsState;
	companyEvents?: CompanyEventsState;
	companyLands?: CompanyLandsState;
	companyTransactions?: CompanyTransactionsState;
	companyEstablishments?: CompanyEstablishmentsState;
	demands?: StoreDemands;
	device?: DeviceSliceInstance;
	geoJson?: GeoJsonState;
	managers?: CompanyManagersState;
	map?: MapSliceInstance;
	matchings_offers_demands?: StoreMatchingOffersDemands;
	offers?: StoreOffers;
	offers_entry?: OffersEntryJsonStore;
	offers_entry_contacts?: OffersEntryContactsStore;
	offers_entry_enums?: OffersEntryEnumsStore;
	offers_entry_location?: OffersEntryLocationStore;
	offers_entry_lots?: OffersEntryLotsStore;
	offers_entry_media?: OffersEntryMediaStore;
	specifications?: StoreSpecifications;
	specification_offers?: StoreCollectionSpecificationOffers;
	status_msgs?: StoreStatusMsgsInstance;
	toast_msgs?: StoreToastMsgsInstance;
	user?: GlobalUser;
}
export const reducers = {
	app: appReducer,
	companies: companiesReducer,
	companyBuildings: companyBuildingsReducer,
	companyEstablishments: companyEstablishmentsReducer,
	companyEvents: companyEventsReducer,
	companyLands: companyLandsReducer,
	companyTransactions: companyTransactionsReducer,
	demands: demandsReducer,
	device: deviceReducer,
	geoJson: geoJsonReducer,
	managers: companyManagersReducer,
	map: mapReducer,
	matchings_offers_demands: matchingOffersDemandsReducer,
	offers: offersReducer,
	offers_entry: offersEntryReducer,
	offers_entry_contacts: offersEntryContactsReducer,
	offers_entry_enums: offersEntryEnumsReducer,
	offers_entry_location: offersEntryLocationReducer,
	offers_entry_lots: offersEntryLotsReducer,
	offers_entry_media: offersEntryMediaReducer,
	specification_offers: specificationOffersReducer,
	specifications: specificationsReducer,
	status_msgs: statusMsgsReducer,
	toast_msgs: toastMsgsReducer,
	user: userReducer,
};
